import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { CommonService } from './service/common/common.service';
import { MsalService } from './msal';
import { filter } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  idleState = 'Not started.';
  timedOut = false;
  showPageContent: boolean = true;
  isUnauthorized: boolean = false;
  title = 'fvm-ui';
  currentRoute: any
  timeoutNumber: number = 3600
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private ngxUiLoaderService: NgxUiLoaderService, private idle: Idle, private commonService: CommonService, private authService: MsalService,) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentRoute = this.router.routerState.snapshot.url;
      console.log('Current Route:', this.currentRoute);
      this.reset()
    });
    console.log(this.timeoutNumber, "timeout seconds")
    this.ngxUiLoaderService.start('loader-component');
    // sets an idle timeout of one hour (3600 sec) for session outing
    idle.setIdle(this.timeoutNumber);
    // sets a timeout period of 1 seconds. after 3600 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(1);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      console.log(this.idleState);
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      if (this.currentRoute !== '/reports/route-pcb' && this.currentRoute !== '/returnables/returns-pcb') {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        console.log(this.idleState);
        localStorage.clear();

        sessionStorage.clear();
        this.authService.logout();

        this.router.navigate(["/"]);
      }
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
      console.log(this.idleState);
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!'
      console.log(this.idleState);
    });



    this.commonService.getUserLoggedIn().subscribe(userLoggedIn => {

      if (userLoggedIn) {
        console.log("After succesful login idle watch is started")
        idle.watch()
        this.timedOut = false;
      } else {
        console.log("After unsuccesful login idle watch is stopped")
        idle.stop();
      }
    })
  }
  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showPageContent = !(event.urlAfterRedirects.includes('/unauthorized'));
        this.isUnauthorized = event.urlAfterRedirects.includes('/unauthorized');
        console.log('this.showPageContent', this.showPageContent)
      }
    });
  }
  reset() {
    this.idle.watch();
    this.timedOut = false;
  }
}